import * as React from "react";

import Input from "src/library/components/Forms/Input";
import { Select } from "src/library/components/Forms";
import { Text } from "src/library/components/Text";
import { Icon } from "src/library/components/Icon";
import Grid from "src/library/components/Hedron";
import { Icons } from "src/library/components/Icon/types";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import ProductTagIconSelector from "src/modules/product-tags/components/ProductTagIconSelector";
import {
  ITag,
  AvailableProductTagIcons
} from "src/modules/product-tags/api/product-tags.api";

interface AdminProductTagsParams {
  onRowChange: <T extends keyof IProcuctTagTemplateTableRow>(property: T, value: IProcuctTagTemplateTableRow[T], uuid: string) => void;
  onRowDelete: (uid: string) => void;
}

export type IProcuctTagTemplateTableRow = ITag & { uid: string; error?: string };
export const adminProductTagsTableColumns = (params: AdminProductTagsParams) => {
  return [
    globalTableColumns.id(),
    globalTableColumns.standardText({
      Header: "Icon",
      accessor: "icon",
      width: 90,
      sortable: false,
      resizable: false,
      Cell: cellProps => {
        return (
          <ProductTagIconSelector
            productTag={cellProps.original}
            onSelect={(type, data) => {
              if (type === "iconCode") {
                params.onRowChange("iconCode", data.iconCode as string, cellProps.original.uid);
                params.onRowChange("icon", null, cellProps.original.uid);
              } else {
                params.onRowChange("icon", data.icon as AvailableProductTagIcons, cellProps.original.uid);
                params.onRowChange("iconCode", null, cellProps.original.uid);
              }
            }}
          />
        );
      }
    }),
    globalTableColumns.standardText({
      Header: "Label",
      accessor: "label",
      width: 200,
      sortable: false,
      resizable: false,
      Cell: cellProps => {
        return (
          <Input
            defaultValue={cellProps.value}
            as="input"
            name={`label-${cellProps.original.uid}`}
            label="label"
            autoHideLabels
            handleBlur={e => params.onRowChange("label", e.target.value, cellProps.original.uid)}
          />
        );
      }
    }),
    globalTableColumns.standardText({
      Header: "Default Info",
      accessor: "info",
      sortable: false,
      resizable: false,
      width: 250,
      Cell: cellProps => {
        return (
          <Input
            defaultValue={cellProps.value}
            as="input"
            name={`info-${cellProps.original.uid}`}
            label="info"
            autoHideLabels
            handleBlur={e => params.onRowChange("info", e.target.value, cellProps.original.uid)}
          />
        );
      }
    }),
    globalTableColumns.standardText({
      Header: "Type",
      accessor: "type",
      sortable: false,
      resizable: false,
      width: 200,
      Cell: cellProps => {
        return (
          <Select
            options={[
              {
                text: "Advisory",
                value: "Advisory"
              },
              {
                text: "Allergen",
                value: "Allergen"
              },
              {
                text: "Dietary & lifestyle",
                value: "Dietary & lifestyle"
              }
            ]}
            defaultValue={cellProps.value}
            as="select"
            name={`type-${cellProps.original.uid}`}
            label="type"
            autoHideLabels
            handleChange={e => params.onRowChange("type", e.target.value, cellProps.original.uid)}
          />
        );
      }
    }),
    globalTableColumns.standardText({
      Header: "Delete",
      accessor: "uid",
      width: 60,
      sortable: false,
      resizable: false,
      Cell: cellProps => {
        return (
          <Grid.Bounds
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={() => params.onRowDelete(cellProps.value)}
          >
            <Icon
              $fillColor="midGrey"
              icon={Icons.CLOSE}
            />
          </Grid.Bounds>
        );
      }
    }),
    globalTableColumns.standardText({
      Header: "",
      accessor: "error",
      width: 500,
      sortable: false,
      Cell: cellProps => {
        return (
          <>
            {!!cellProps.value && !!cellProps.value.length && (
              <Text color="error">
                {cellProps.value}
              </Text>
            )}
          </>
        );
      }
    })
  ];
};
